
import { Box, IconButton, Link, Typography } from "@mui/material";
import { useRouteHistory } from "../../contexts/route-history-context/UseRouteHistory";
import { GoBackIcon } from "../action-menu/ActionMenuIcons";

export type BackButtonV2Props = {
    onGoingBack?: () => boolean;
    color?: string;
};

export default function BackButtonV2({ onGoingBack, color }: BackButtonV2Props) {
    const [routeHistory, goBack] = useRouteHistory();
    const visible = routeHistory.length > 1;
    
    function onGoBack(/*event: React.MouseEvent<HTMLAnchorElement>*/) {
        let shouldContinue = true;
        if (onGoingBack) {
            shouldContinue = onGoingBack();
        }

        if(shouldContinue){
            goBack();
        }
    }


    //console.log(`BackButtonV2: ${visible} routeHistory: ${JSON.stringify(routeHistory)}`)
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            flexShrink: 0,
            alignItems: "center",
        }}>
            {visible &&
                <Link sx={{
                    marginTop: 'auto', 
                    marginBottom: 'auto',
                    display: 'inline-flex'
                }}
                    aria-label="go back"
                    onClick={onGoBack}
                    color={color}
                >
                    <IconButton size="large"
                        edge='start' 
                        component="span"  
                        sx={{ color: color
                        //, mr: 2
                        }}>
                        <GoBackIcon />
                    </IconButton>
                    <Typography
                        variant='body2'
                        sx={{ 
                            marginTop: 'auto', 
                            marginBottom: 'auto',
                            mr: 2
                    }}>
                        Back
                        </Typography>
                </Link>
            }
        </Box>
    );
}